export default __webpack_public_path__ + "static/media/star.cf11df0f.svg";